import React, { useState } from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Button,
  Typography,
} from "@material-tailwind/react";
import { useReduxStore } from "../hooks/useReduxStore";
import { GenerateKeyAction } from "../store/Actions/action";

export default function KeyGenerateModal({ open, onClose, onGenerate }) {
  const {getState,dispatch}=useReduxStore()
  const {loading}=getState("AUTH")
  const [keyName, setKeyName] = useState("");
  // const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGenerate = async () => {
    if (!keyName.trim()) {
      setError("Please enter a key name.");
      return;
    }
let param={label:keyName}
setKeyName("")
onClose()
dispatch(GenerateKeyAction(param),
)
  };

  return (
    <Dialog
      open={open}
      handler={onClose}
      size="sm"
      className={`rounded-xl shadow-xl bg-blueGray border border-borderGray ${loading?"!z-40":""}`}
      animate={{
        mount: { scale: 1, y: 0 },
        unmount: { scale: 0.95, y: -100 },
      }}
    >
      <DialogHeader className="text-xl font-semibold text-white border-b border-borderGray bg-[#384355] rounded-t-xl">
        <div className="flex items-center space-x-2">
          <span>🔐</span>
          <span>Generate New API Key</span>
        </div>
      </DialogHeader>

      <DialogBody className="py-6 px-6 bg-blueGray">
        <div className="flex flex-col gap-4">
          <Typography variant="small" className="text-gray-300">
            Enter a name for your new key. This will help you identify it later.
          </Typography>

          <div>
            <label className="block text-sm font-medium text-white mb-2">
              Key Name
            </label>
            <input
              type="text"
              value={keyName}
              onChange={(e) => setKeyName(e.target.value)}
              placeholder="Enter key name"
              className="w-full p-3 bg-[#384355] border border-borderGray text-white rounded-lg focus:ring-2 focus:ring-primaryBlue focus:border-transparent placeholder-gray-400"
            />
          </div>

          {error && (
            <div className="text-red-400 text-sm font-medium">
              {error}
            </div>
          )}
        </div>
      </DialogBody>

      <DialogFooter className="px-6 pb-6 pt-2 bg-blueGray rounded-b-xl">
        <button
          onClick={onClose}
          className="mr-2 px-4 py-2 border border-borderGray text-gray-300 rounded-lg hover:bg-gray-700 transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={handleGenerate}
          disabled={loading}
          className="px-4 py-2 bg-primaryBlue hover:bg-primaryBlue/90 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Generating..." : "Generate"}
        </button>
      </DialogFooter>
    </Dialog>
  );
}
